import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

type GenderData = {
  Name: string;
  Value: number;
};

export const GenderDistributionView = ({ data }: { data?: GenderData[] }) => {
  const chartData =
    data && data.length > 0
      ? data.map(item => ({
        name: item.Name,
        y: item.Value,
      }))
      : [{ name: 'No Data', y: 1, color: '#d9d9d9' }]; // fallback slice

  const options: Highcharts.Options = {
    chart: {
      type: 'pie',
    },
    title: {
      text: 'Gender Distribution',
    },
    tooltip: {
      pointFormat: '<b>{point.percentage:.1f}%</b>',
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
        },
      },
    },
    colors: ['#FF69B4', '#4169E1', '#808080'],
    series: [
      {
        name: 'Genders',
        type: 'pie',
        data: chartData,
      },
    ],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
